import LogoAnimationBtn from '../../components/LogoAnimationBtn';
import LogoArea from '../../components/LogoArea';
import Event from '../../components/Event';
//import MagneticButton from '../../components/MagneticButton';
import throttle from 'lodash.throttle';

let view = null;

class Home {
	constructor(container) {
		this.container = container;
		this.breakpoint = window.matchMedia('(orientation: portrait)');

		this.grid = document.querySelector('[data-number-grid]');

		this.subscribeButton = this.container.querySelector('[data-subscribe-button]');
		this.subscribeButton.addEventListener('click', (evt) => {
			const toggleModalEvent = new CustomEvent('toggle-subscribe-modal');
			document.dispatchEvent(toggleModalEvent);
		});
	}

	init() {
		if (this.breakpoint.matches === true) {
			// Portrait
			this.animationArea = this.container.querySelector('.t-homepage__area');
			this.areas = [];
			this.areas.push(new LogoArea(this.animationArea));
		} else {
			// Landscape
			this.animationAreas = this.container.querySelectorAll('.t-homepage__area');
			this.areas = [...this.animationAreas].map((area) => new LogoArea(area));
		}

		// this.magneticButtons = this.container.querySelectorAll('[data-magnetic]');
		// this.magneticButtons.forEach((btn) => {
		// 	new MagneticButton(btn, this);
		// });

		// Events
		const events = this.container.querySelectorAll('[data-event]');
		events.forEach((event) => {
			new Event(event);
		});

		this.logoAnimationButtons = document.querySelectorAll('[data-animation]');
		this.logoAnimationButtons.forEach((btn) => {
			new LogoAnimationBtn(btn, this);
		});

		this.boundScrollListener = throttle(this.handleScroll.bind(this), 0);
		window.addEventListener('scroll', this.boundScrollListener);
		this.handleScroll();
	}

	handleScroll() {
		if (window.scrollY > window.innerHeight / 3) {
			this.grid.classList.remove('c-grid--shownumbers');
		} else {
			this.grid.classList.add('c-grid--shownumbers');
		}
	}

	destroy() {
		document.removeEventListener('bless', this.boundHandleBless);
		document.removeEventListener('scroll', this.boundScrollListener);
	}
}

export default {
	namespace: 'home',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Home(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
